module.exports = __webpack_public_path__ + "static/img/play-store.8bf75283.png";